// See README.md for more info about field configuration

import { FIELD_TYPE, REFDATA_MAP } from '@/constants'
import moment from 'moment'

import _get from 'lodash/get'

import { age } from './age'

export const newHouseHold = {
  name: '',
  dob: '',
  age: '',
  relationship: ''
}

export default function getHouseHold(key) {
  return {
    apiKey: key,
   // elemId: houseHoldsScroll,
    type: FIELD_TYPE.COLLECTION,
    collapsible: true,
    showLine: true,
    visible(application) {
      if (application.housing.noOfHouseHold > 0) {
        return true
      }
      return false
    },
    heading(item,index) {
      return `Person  ${index}`
    },
    headingAdd:  'Add New Person',
    headingAddOutline: true,
    //headingAdd: 'Add another Houseing Hold',
    newItem: { ...newHouseHold },
    fields(item, index) {
      var apiKeyPrefix = `housing.houseHolds[${index}]`
            
            return [
              {
                apiKey: `${apiKeyPrefix}.name`,
                label: 'Name',
                placeHolder: 'Enter name',
                type: FIELD_TYPE.NAME,
                maxLength: 100,
                required: true
              },
              {
                apiKey: `${apiKeyPrefix}.dob`,
                label: 'Birth Date',
                required: true,
                type: FIELD_TYPE.DATE,
                pastYears: 150,
                futureYears: 0,
                validation(value) {
                  if (moment(value) > moment()) {
                    return 'Cannot be a future date'
                  }
                },
                onFieldSet(value, application, store) {
                  store.dispatch('set', [
                    `application.${apiKeyPrefix}.age`,
                    age(value)
                  ])
              }
              },
              {
                apiKey: `${apiKeyPrefix}.age`,
                label: 'Age',
                required: true,          
                placeHolder: 'Age derived from date of birth',
                required: true,
                disabled: true
              },
              {
                apiKey: `${apiKeyPrefix}.relationship`,
                label: 'Relationship',
                placeHolder: 'Enter Relationship',
                maxLength: 100,
                required: true
              },
              {
                apiKey: `${apiKeyPrefix}.employed`,
                label: 'Employed?',                
                type: FIELD_TYPE.TEXTAREA,
                required: true
              }
            ]
          }
    }
  }

